<template>
  <div>
    <layout-no-padding>
      <v-icon
        v-if="!noIcon"
        class="pr-2"
        :color="routeProps.color"
      >{{$route.name == 'confirmedTrip' ? $store.state.global.pages.rcti.icon : routeProps.icon}}</v-icon>
      <h1
        class="title grey--text text--darken-1 vertical-center-container mt-1"
      >{{!!custom ? title : routeProps.title}}</h1>
    </layout-no-padding>
    <div class="body-2 grey--text" v-if="!custom">{{routeProps.content}}</div>
  </div>
</template>

<script>
export default {
  props: {
    routeProps: Object,
    custom: Boolean,
    title: String,
    noIcon: Boolean
  }
};
</script>

<style>
</style>
